import { render } from "./Site2.vue?vue&type=template&id=8a28c304&scoped=true"
import script from "./Site2.vue?vue&type=script&lang=js"
export * from "./Site2.vue?vue&type=script&lang=js"

import "./Site2.vue?vue&type=style&index=0&id=8a28c304&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a28c304"]])

export default __exports__
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCarousel,QCarouselSlide});
